export const SET_T_SHIRTS = 'SET_T_SHIRTS';


// WEBPACK FOOTER //
// ./src/store/modules/t-shirts/mutations.js